import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config'; 



@Injectable()
export class TeamReportService {
    constructor(
        private httpService: HttpService) { }

  

    //获取团队报表信息
    //TQQ 2016-12-29
    getTeamReport(userName: string, startDate, endDate, pageIndex: number, pageSize: number) { 
        let param = "start=" + startDate + "&end=" + endDate + "&pageSize=" + pageSize + "&pageIndex=" + pageIndex + "&userName=" + userName;
        let url = AppConfig.GetProdUrl() + "/Team/QueryTeamReport?" + param;
        return this.httpService.get(url);
    }


}





// WEBPACK FOOTER //
// ./src/services/teamreport.service.ts